import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ActivatedRoute, Router } from '@angular/router';
//import { RouteParams } from '@angular/common'

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule {

  constructor(
    private router: Router,
    private activeRoute: ActivatedRoute,
    //private start: NavigationStart,
    //private params: RouteParams
  ) {


  }

}
